import React from 'react';
import { useSirenEntity } from '~/utility/BinSentry-ui-utility';
import { CircularProgress } from '~/lib/bn-material-ui';
import Initialize from './initialize';
import UnmonitoredSetup from './unmonitored-setup';
import Monitored from './monitored';
import Unmonitored from './unmonitored';

const showUnmonitoredSetup = (bin) => {
  const { monitoringType, consumptionRate, listedCapacity } = bin.properties;
  return monitoringType === 'unmonitored' && !(consumptionRate && listedCapacity);
};

const showUnmonitored = (bin) => {
  const { monitoringType, consumptionRate, listedCapacity } = bin.properties;
  return monitoringType === 'unmonitored' && consumptionRate && listedCapacity;
};

const showMonitored = (bin) => {
  return bin.properties.monitoringType === 'monitored' || bin.properties.isAggregate === true;
};

export default function LevelHistory({ href }) {
  const { entity: bin } = useSirenEntity({ href: href });

  // prettier-ignore
  return !bin ? <CircularProgress />
    : showMonitored(bin) ? <Monitored href={href} bin={bin} />
      : showUnmonitored(bin) ? <Unmonitored href={href} bin={bin} />
        : showUnmonitoredSetup(bin) ? <UnmonitoredSetup href={href} bin={bin} />
          : <Initialize action={bin.getAction('update-monitoring-type')} href={href} />;
}
